import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ExpandDown"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M2.24976 3.75H21.7498V5.25H2.24976V3.75Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M2.24976 8.75098H21.7498V10.251H2.24976V8.75098Z" }, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", { d: "M11.9997 19.0496L2.86818 11.9473L1.94727 13.1313L11.5393 20.5917C11.8101 20.8024 12.1894 20.8024 12.4602 20.5917L22.0522 13.1313L21.1313 11.9473L11.9997 19.0496Z" }, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ExpandDown.vue"]]);
